(function () {
  'use strict';
  var root = document.querySelector('[data-xg-lpi="label-test"]');
  if (!root) return;
  var QS = [
    { t: 'What is the serving size on this label? Tap the line that says.', a: 'serving',
      ok: 'One strip. The panel is written for one serving, not the whole tin.',
      no: 'The serving size sits at the top, under the title. The panel is written for one serving, not the whole tin.' },
    { t: 'How much of an active is in one serving? Tap a line that tells you.', a: 'amount',
      ok: 'Read the number and its unit together. An amount with no unit tells you nothing; mcg, mg and g are a thousand-fold apart.',
      no: 'Look for a line with a figure beside the name. Read the number and its unit together: mcg, mg and g are a thousand-fold apart.' },
    { t: 'One active shows no %DV. Tap it.', a: 'nodv',
      ok: 'No Daily Value has been established for it. A blank is not zero.',
      no: 'The dagger marks it. No Daily Value has been established for it, and a blank is not zero.' },
    { t: 'The label lists a blend with one total. Tap the blend.', a: 'blend',
      ok: 'You cannot tell how much of each is in it. A blend prints one total for several actives, so each amount is hidden.',
      no: 'The bold total with ingredients indented under it is the blend. It prints one total, so each amount is hidden.' },
    { t: 'Where do you find the sweetener and the film? Tap it.', a: 'other',
      ok: 'In Other Ingredients. The panel holds the actives; flavour, sweetener and film sit below it.',
      no: 'Other Ingredients, under the panel. The panel holds the actives; flavour, sweetener and film sit below it.' }
  ];
  var i = 0, got = 0, locked = false;
  var L = root.querySelector('[data-label]');
  var dots = root.querySelectorAll('.xg-lpi-dots__dot');
  var qn = root.querySelector('[data-qn]');
  var qt = root.querySelector('[data-qt]');
  var fb = root.querySelector('[data-fb]');
  var next = root.querySelector('[data-next]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show() {
    qn.textContent = 'Question ' + (i + 1) + ' of 5';
    qt.textContent = QS[i].t;
    fb.textContent = 'Tap the part of the label the question asks about.';
    fb.className = 'xg-lpi-toast';
    next.hidden = true;
    var rows = L.querySelectorAll('.xg-lpi-line');
    for (var j = 0; j < rows.length; j++) { rows[j].classList.remove('is-hit'); rows[j].classList.remove('is-miss'); }
    for (j = 0; j < dots.length; j++) dots[j].classList.toggle('is-now', j === i);
    locked = false;
  }
  function pick(e) {
    if (locked) return;
    var r = e.target.closest('.xg-lpi-line[data-part]');
    if (!r) return;
    locked = true;
    var q = QS[i];
    var right = r.getAttribute('data-part') === q.a;
    if (right) { got++; r.classList.add('is-hit'); }
    else {
      r.classList.add('is-miss');
      var hits = L.querySelectorAll('[data-part="' + q.a + '"]');
      for (var j = 0; j < hits.length; j++) hits[j].classList.add('is-hit');
    }
    dots[i].className = 'xg-lpi-dots__dot ' + (right ? 'is-ok' : 'is-no');
    fb.textContent = right ? q.ok : q.no;
    fb.className = 'xg-lpi-toast ' + (right ? 'is-ok' : 'is-no');
    next.hidden = false;
    next.textContent = i < 4 ? 'Next question' : 'See your score';
  }
  L.addEventListener('click', pick);
  L.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(e); }
  });
  next.addEventListener('click', function () {
    i++;
    if (i < 5) { show(); return; }
    root.querySelector('[data-q]').hidden = true;
    root.querySelector('[data-intro]').hidden = true;
    root.querySelector('[data-desk]').hidden = true;
    root.querySelector('[data-got]').textContent = String(got);
    root.querySelector('[data-verdict]').textContent =
      got === 5 ? 'You read labels. So do we: every XYNE active is printed with its amount.' :
      got >= 3 ? 'Close. The gaps are exactly where a label can hide things.' :
      'Labels are built to be skimmed past. That is the point of this one.';
    root.querySelector('[data-end]').hidden = false;
    root.scrollIntoView({ block: 'start' });
  });
  var again = root.querySelector('[data-again]');
  if (again) again.addEventListener('click', function (e) { e.preventDefault(); location.reload(); });
  show();
  function tilt(el, host) {
    if (reduced || !el || !host) return;
    host.addEventListener('pointermove', function (e) {
      var r = host.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * 16) + 'deg) rotateX(' + (6 - y * 12) + 'deg) rotate(-1.5deg)';
    });
  }
  tilt(root.querySelector('[data-hero-img]'), root.querySelector('[data-hero]'));
  tilt(L, root.querySelector('[data-desk]'));
})();
